import Es from "../../assets/images/flags/es.svg?react";

export default Es;
